var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.rtlClass,attrs:{"id":"app"}},[_c('div',{staticClass:"bgc-red-color"},[_c('navbar',{attrs:{"changeRtl":_vm.changeRtl}}),_c('div',{staticClass:"main-layout page-setting"},[_c('router-view')],1),_c('site-footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }